export default {
	firestorePath: "questions",
	firestoreRefType: "collection",
	moduleName: "questions",
	statePropName: "data",
	namespaced: true,
	state: {},
	sync: {
		where: [["status", "in", ["published"]]],
	},
	serverChange: {},

	getters: {
		title(state) {
			return (id) => {
				let question = state.data[id];
				if (!question || !id) {
					return "";
				}
				if (question.type == "html") {
					return question.content;
				}
				return question.title;
			};
		},
		isLabelled(state) {
			return (id) => {
				let question = state.data[id];
				if (!id || !question) {
					return null;
				}
				let questionType = question.type;
				let labelledTypes = ["checkboxes", "tiles"];
				return labelledTypes.includes(questionType);
			};
		},
		isHierarchical(state) {
			return (id) => {
				let question = state.data[id];
				if (!id || !question) {
					return null;
				}
				let questionType = question.type;
				let hierarchicalTypes = ["matrix"];
				return hierarchicalTypes.includes(questionType);
			};
		},
		isMultiple(state) {
			return (id) => {
				let question = state.data[id];
				if (!id || !question) {
					return null;
				}
				return question.multiple;
			};
		},
		labelledAnswer(state) {
			return (id, value) => {
				let question = state.data[id];
				let answer = question.answer_options[value];
				if (!answer) {
					return value;
				}
				return answer.text || value;
			};
		},
		textAnswer(_, getters) {
			return (id, value) => {
				if (getters.isLabelled(id)) {
					return getters.labelledAnswer(id, value);
				}
				return value;
			};
		},
		hierarchicalAnswer(state, getters) {
			return (id, value) => {
				let question = state.data[id];
				return Object.keys(value).map((q) => {
					let v = value[q];
					if( !question.subquestions ){
						return;
					}
					let subquestion = question.subquestions[q];
					if( !subquestion ){
						return;
					}
					let answer = "";
					if (subquestion) {
						answer = `</i>${subquestion.text}: </i>`;
					}
					answer += getters.textAnswer(id, v);
					answer += "\n";
					return answer;
				});
			};
		},
		parseValueToString(_, getters) {
			return (id, value) => {
				if (!value) {
					return "";
				}
				if (Array.isArray(value)) {
					// if (getters.isHierarchical(id)) {
					// 	return getters.hierarchicalAnswer(id, value);
					// } else {
					try {
						return value.map((v) => getters.textAnswer(id, v)).join(", ");
					} catch {
						return "";
					}
					// }
				} else {
					return getters.textAnswer(id, value);
				}
			};
		},
	},
	mutations: {},
	actions: {},
	model: {},
};
